import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8.5 21.5v-4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v4h-7Z" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "11",
  r: "2.5"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M21.5 5c0-1.38-4.253-2.5-9.5-2.5S2.5 3.62 2.5 5m19 0v10.5c0 .841-1.58 1.585-4 2.039v-10.5c2.42-.453 4-1.198 4-2.039Zm-19 0c0 .841 1.58 1.586 4 2.039v10.5c-2.42-.454-4-1.198-4-2.039V5Z" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }